import React from 'react';
import SelectStepTemplate from '../../../template/SelectStepTemplate';
import useGetMateriais, {
  buildOutrosAviamentos,
  buildOutrosTecidos,
} from '../../../template/UseGetMateriais';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import SobraMateriaPrimaFinalStep from './SobraMateriaPrimaFinalStep';

const SobraMateriaPrima: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais();
  const newMateriais = [
    ...materiais,
    buildOutrosTecidos(),
    buildOutrosAviamentos(),
  ];

  const stepNumber = '2';
  const stepSubTitle = 'Selecione a matéria-prima com sobra.';
  const stepTitle = 'Qual matéria-prima está sobrando?';
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={SobraMateriaPrimaFinalStep as TipoDivergenciaComponent}
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey='materiais'
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default SobraMateriaPrima;
